import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const RouteAndScheduleRBAC = {
  pageID: 'b37cfe2d21659959fc0cdd2fcd97e7b7',
  elementID: {
    ViewPage: 'a71747a835595cf171e60de2774498a1',
    BtnBulkUpload: 'd73b068cc2f342084c59ce08d4dc45b6',
    BtnAddRouteAndSchedule: 'ebd525c60486778a6570ac19d9ff3f9b',
    BtnEditRouteAndSchedule: '573c65e6b2a67d3b314d28a2708aa6a0',
    BtnToggleStatusActive: 'a67b45cabdb02628293dc540bf402abd',
  },
}
export const useRBACRouteAndSchedulePage = createUseRBAC(RouteAndScheduleRBAC.elementID)
export type UseRBACRouteAndSchedulePageType = ReturnType<typeof useRBACRouteAndSchedulePage>

export const RouteAndScheduleUpsertRBAC = {
  pageID: '6188a9cddba406d334bb20b6197d7dd6',
  elementID: {
    ViewPage: '7e895e045c3730a95e05fdea177316e0',
  },
}
export const useRBACRouteAndScheduleUpsertPage = createUseRBAC(RouteAndScheduleUpsertRBAC.elementID)
export type UseRBACRouteAndScheduleUpsertPageType = ReturnType<
  typeof useRBACRouteAndScheduleUpsertPage
>
